export default __webpack_public_path__ + "static/media/race_room.1235669c.gif";